import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Alert, Box, Button, Chip, CircularProgress, Container, Paper, Stack, Typography} from '@mui/material';
import ApiService from '../network/API';

const STATE_LABEL = {NOT_STARTED: 'Ещё не начат', ACTIVE: 'Идёт', FINISHED: 'Завершён'};

const gradeColor = (g) => (g >= 5 ? 'success' : g >= 4 ? 'primary' : g >= 3 ? 'warning' : 'error');

// Экзамены студента: список по предметам с состоянием и оценкой, переход к идущему экзамену.
const ExamsPage = () => {
    const navigate = useNavigate();
    const [exams, setExams] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        document.title = 'Экзамены';
        ApiService.getMyAllExams()
            .then((list) => setExams(Array.isArray(list) ? list : []))
            .catch((e) => setError(e?.reason || e?.message || 'Не удалось загрузить экзамены'));
    }, []);

    if (error) return <Container maxWidth="sm" sx={{py: 4}}><Alert severity="error">{error}</Alert></Container>;
    if (!exams) return <Box display="flex" justifyContent="center" py={8}><CircularProgress/></Box>;

    return (
        <Container maxWidth="sm" sx={{py: 4}}>
            <Typography variant="h4" fontWeight={700} gutterBottom>Экзамены</Typography>
            {exams.length === 0 ? (
                <Typography color="text.secondary">Пока для вашей группы нет экзаменов.</Typography>
            ) : (
                <Stack spacing={1.5}>
                    {exams.map((ex) => {
                        const attempt = ex.attempt;
                        const grade = attempt?.grade;
                        return (
                            <Paper key={ex.eventId} variant="outlined" sx={{p: 2, borderRadius: 2, cursor: 'pointer', '&:hover': {borderColor: 'primary.main'}}}
                                   onClick={() => navigate(`/exams/event/${ex.eventId}`)}>
                                <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap" useFlexGap>
                                    <Box sx={{flex: 1, minWidth: 180}}>
                                        <Typography fontWeight={700}>{ex.title}</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {ex.tagName} · {ex.durationMinutes} мин
                                        </Typography>
                                        {ex.state === 'NOT_STARTED' && (
                                            <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
                                                Преподаватель откроет доступ и выдаст билет в начале экзамена.
                                            </Typography>
                                        )}
                                        {attempt?.comment && (
                                            <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>{attempt.comment}</Typography>
                                        )}
                                    </Box>
                                    {grade != null ? (
                                        <Chip color={gradeColor(grade)} label={`Оценка: ${grade}`} sx={{fontWeight: 700}}/>
                                    ) : (
                                        <Chip
                                            size="small"
                                            variant="outlined"
                                            color={ex.state === 'ACTIVE' ? 'primary' : 'default'}
                                            label={ex.state === 'FINISHED' ? 'Оценка не выставлена' : STATE_LABEL[ex.state] || ex.state}
                                        />
                                    )}
                                    <Button size="small" variant={ex.state === 'ACTIVE' ? 'contained' : 'outlined'}>
                                        {ex.state === 'ACTIVE' ? 'Экзамен идёт' : 'Открыть'}
                                    </Button>
                                </Stack>
                            </Paper>
                        );
                    })}
                </Stack>
            )}
        </Container>
    );
};

export default ExamsPage;
